import { createContext } from 'react';

import { HistoryOfChangesItem } from 'pages/item/v2/types/history-of-changes';

export interface HistoryOfChangesContext {
    data: HistoryOfChangesItem[];
    isLoading: boolean;
    load: () => void;
    revision: HistoryOfChangesItem | null;
    version: number;
    setVersion: (version: number) => void;
}

const defaultValue: HistoryOfChangesContext = {
    data: [],
    isLoading: false,
    load: () => {},
    revision: null,
    version: 0,
    setVersion: () => {}
};

const historyOfChangesContext = createContext(defaultValue);
export default historyOfChangesContext;
